import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { reportAPI, type ReportListItem } from '@/lib/api/reports'

export default function ReportsListPage() {
  const [reports, setReports] = useState<ReportListItem[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    reportAPI
      .listReports()
      .then((r) => setReports(r.data.reports))
      .catch((e) => setError(String(e)))
  }, [])

  if (error) return <div className="p-8 text-red-600">Failed to load reports: {error}</div>
  if (!reports) return <div className="p-8">Loading reports…</div>
  return (
    <div className="mx-auto max-w-3xl p-8">
      <h1 className="mb-6 text-2xl font-semibold">Reports</h1>
      {reports.length === 0 && <p>No reports yet — ask the assistant to create one.</p>}
      <ul className="divide-y">
        {reports.map((r) => (
          <li key={r.report_id} className="py-3">
            <Link to={`/reports/${r.report_id}`} className="font-medium hover:underline">
              {r.title}
            </Link>
            <span className="ml-2 text-sm text-muted-foreground">
              {r.profile_id} · v{r.version} · {r.status} · {new Date(r.created_at).toLocaleString()}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
